import { http } from '@/http'

/**
 * Adendas de contrato: PDFs adjuntos a un contrato (múltiples, historial). Reusa el patrón multipart
 * de ContractsService (uploadSignedDocument / uploadCessationDocument).
 *
 * Endpoints (baseURL ya incluye /api/v1):
 *   GET    /contracts/{contractId}/addenda
 *   POST   /contracts/{contractId}/addenda            (multipart: file + description opcional)
 *   GET    /contracts/{contractId}/addenda/{id}/download   (blob)
 *   DELETE /contracts/{contractId}/addenda/{id}
 */
export default {
  list(contractId) {
    return http.get(`/contracts/${contractId}/addenda`)
  },
  salaryHistory(contractId) {
    return http.get(`/contracts/${contractId}/addenda/salary-history`)
  },
  // opts (opcional): adenda multi-campo. { changedFields: [], newBaseSalary, newPositionId, newAreaId,
  // newChannelId, newExpenseLineId, newWorkSiteId, newDirectManagerId, newHrResponsibleEmail,
  // effectiveDate, reason }. Compat: si viene opts.changeType (sin changedFields), se envía como antes.
  upload(contractId, file, description, opts = {}) {
    const formData = new FormData()
    formData.append('file', file)
    if (description) formData.append('description', description)
    if (Array.isArray(opts.changedFields)) {
      // Siempre enviar la clave (aunque vacía) para que el backend tome el camino multi-campo.
      opts.changedFields.forEach(f => formData.append('changedFields', f))
      if (opts.changedFields.length === 0) formData.append('changedFields', '')
    } else if (opts.changeType) {
      formData.append('changeType', opts.changeType)
    }
    if (opts.newBaseSalary != null) formData.append('newBaseSalary', opts.newBaseSalary)
    if (opts.newPositionId != null) formData.append('newPositionId', opts.newPositionId)
    if (opts.newAreaId != null) formData.append('newAreaId', opts.newAreaId)
    if (opts.newChannelId != null) formData.append('newChannelId', opts.newChannelId)
    if (opts.newExpenseLineId != null) formData.append('newExpenseLineId', opts.newExpenseLineId)
    if (opts.newWorkSiteId != null) formData.append('newWorkSiteId', opts.newWorkSiteId)
    if (opts.newDirectManagerId != null) formData.append('newDirectManagerId', opts.newDirectManagerId)
    if (opts.newHrResponsibleEmail) formData.append('newHrResponsibleEmail', opts.newHrResponsibleEmail)
    if (opts.effectiveDate) formData.append('effectiveDate', opts.effectiveDate)
    if (opts.reason) formData.append('reason', opts.reason)
    return http.post(`/contracts/${contractId}/addenda`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  // DEF-004: adenda masiva. data = { contractIds:[], changedFields:[], newBaseSalary, newPositionId,
  // newAreaId, newChannelId, newExpenseLineId, newWorkSiteId, newDirectManagerId,
  // newHrResponsibleEmail, effectiveDate, reason, description, file }.
  // POST /contracts/addenda/bulk (multipart). Response: BulkAddendumResultDto { created, failed, results[] }.
  bulk(data) {
    const formData = new FormData()
    ;(data.contractIds || []).forEach(id => formData.append('contractIds', id))
    ;(data.changedFields || []).forEach(f => formData.append('changedFields', f))
    if (data.newBaseSalary != null) formData.append('newBaseSalary', data.newBaseSalary)
    if (data.newPositionId != null) formData.append('newPositionId', data.newPositionId)
    if (data.newAreaId != null) formData.append('newAreaId', data.newAreaId)
    if (data.newChannelId != null) formData.append('newChannelId', data.newChannelId)
    if (data.newExpenseLineId != null) formData.append('newExpenseLineId', data.newExpenseLineId)
    if (data.newWorkSiteId != null) formData.append('newWorkSiteId', data.newWorkSiteId)
    if (data.newDirectManagerId != null) formData.append('newDirectManagerId', data.newDirectManagerId)
    if (data.newHrResponsibleEmail) formData.append('newHrResponsibleEmail', data.newHrResponsibleEmail)
    if (data.effectiveDate) formData.append('effectiveDate', data.effectiveDate)
    if (data.reason) formData.append('reason', data.reason)
    if (data.description) formData.append('description', data.description)
    if (data.file) formData.append('file', data.file)
    return http.post('/contracts/addenda/bulk', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  download(contractId, id) {
    return http.get(`/contracts/${contractId}/addenda/${id}/download`, { responseType: 'blob' })
  },
  delete(contractId, id) {
    return http.delete(`/contracts/${contractId}/addenda/${id}`)
  },
}
